import React, { useState, useEffect, useRef } from "react";
import "../styles/Modal.css";
import "../styles/societeModal.css";
import { Company, Contact } from "../types";

interface SocieteModalProps {
  onClose: () => void;
  onSubmit: (data: Company) => Promise<void>;
  initialData?: Company;
  openInsee?: boolean;
}

export const countries = [
  { value: "Albania", label: "Albanie" },
  { value: "Algeria", label: "Algérie" },
  { value: "Germany", label: "Allemagne" },
  { value: "Saudi Arabia", label: "Arabie saoudite" },
  { value: "Argentina", label: "Argentine" },
  { value: "Australia", label: "Australie" },
  { value: "Austria", label: "Autriche" },
  { value: "Bangladesh", label: "Bangladesh" },
  { value: "Belgium", label: "Belgique" },
  { value: "Belarus", label: "Biélorussie" },
  { value: "Brazil", label: "Brésil" },
  { value: "Bosnia and Herzegovina", label: "Bosnie-Herzégovine" },
  { value: "Bulgaria", label: "Bulgarie" },
  { value: "Canada", label: "Canada" },
  { value: "Chile", label: "Chili" },
  { value: "China", label: "Chine" },
  { value: "Colombia", label: "Colombie" },
  { value: "South Korea", label: "Corée du Sud" },
  { value: "Croatia", label: "Croatie" },
  { value: "Ivory Coast", label: "Côte d'Ivoire" },
  { value: "Denmark", label: "Danemark" },
  { value: "Egypt", label: "Égypte" },
  { value: "United Arab Emirates", label: "Émirats arabes unis" },
  { value: "Spain", label: "Espagne" },
  { value: "United States", label: "États-Unis" },
  { value: "Estonia", label: "Estonie" },
  { value: "Finland", label: "Finlande" },
  { value: "France", label: "France" },
  { value: "La Reunion", label: "La Réunion" },
  { value: "Greece", label: "Grèce" },
  { value: "Hungary", label: "Hongrie" },
  { value: "India", label: "Inde" },
  { value: "Indonesia", label: "Indonésie" },
  { value: "Ireland", label: "Irlande" },
  { value: "Iceland", label: "Islande" },
  { value: "Israel", label: "Israël" },
  { value: "Italy", label: "Italie" },
  { value: "Japan", label: "Japon" },
  { value: "Kosovo", label: "Kosovo" },
  { value: "Kuwait", label: "Koweït" },
  { value: "Latvia", label: "Lettonie" },
  { value: "Liechtenstein", label: "Liechtenstein" },
  { value: "Lithuania", label: "Lituanie" },
  { value: "Luxembourg", label: "Luxembourg" },
  { value: "North Macedonia", label: "Macédoine du Nord" },
  { value: "Madagascar", label: "Madagascar" },
  { value: "Malaysia", label: "Malaisie" },
  { value: "Malta", label: "Malte" },
  { value: "Mexico", label: "Mexique" },
  { value: "Moldova", label: "Moldavie" },
  { value: "Monaco", label: "Monaco" },
  { value: "Montenegro", label: "Monténégro" },
  { value: "New Zealand", label: "Nouvelle-Zélande" },
  { value: "Norway", label: "Norvège" },
  { value: "Netherlands", label: "Pays-Bas" },
  { value: "Pakistan", label: "Pakistan" },
  { value: "Peru", label: "Pérou" },
  { value: "Philippines", label: "Philippines" },
  { value: "Poland", label: "Pologne" },
  { value: "Portugal", label: "Portugal" },
  { value: "Qatar", label: "Qatar" },
  { value: "Czech Republic", label: "République tchèque" },
  { value: "Romania", label: "Roumanie" },
  { value: "United Kingdom", label: "Royaume-Uni" },
  { value: "Russia", label: "Russie" },
  { value: "San Marino", label: "Saint-Marin" },
  { value: "Senegal", label: "Sénégal" },
  { value: "Serbia", label: "Serbie" },
  { value: "Singapore", label: "Singapour" },
  { value: "Slovakia", label: "Slovaquie" },
  { value: "Slovenia", label: "Slovénie" },
  { value: "South Africa", label: "Afrique du Sud" },
  { value: "Sweden", label: "Suède" },
  { value: "Switzerland", label: "Suisse" },
  { value: "Thailand", label: "Thaïlande" },
  { value: "Tunisia", label: "Tunisie" },
  { value: "Turkey", label: "Turquie" },
  { value: "Ukraine", label: "Ukraine" },
  { value: "Vatican City", label: "Vatican" },
  { value: "Vietnam", label: "Vietnam" }
];

const INSEE_API_KEY = (process.env.REACT_APP_INSEE_API_KEY as string) || "";

const SocieteModal: React.FC<SocieteModalProps> = ({
  onClose,
  onSubmit,
  initialData,
  openInsee = false,
}) => {
  const [siret, setSiret] = useState("");
  const [name, setName] = useState("");
  const [address, setAddr] = useState("");
  const [postalCode, setPost] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");

  const [gender, setGender] = useState("Mr");
  const [nomC, setNomC] = useState("");
  const [prenomC, setPrenomC] = useState("");
  const [telC, setTelC] = useState("");
  const [mailC, setMailC] = useState("");
  const [fonctionC, setFonctionC] = useState("");

  const [extras, setExtras] = useState<Contact[]>([]);

  const [showSearch, setShowSearch] = useState(true);
  const [sirenInput, setSirenInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState<any[]>([]);
  const [searched, setSearched] = useState(false);
  const searchRef = useRef<HTMLInputElement>(null);

  const [formVisible, setFormVisible] = useState(!openInsee || !!initialData);

  useEffect(() => {
    if (!initialData) return;
    setSiret(initialData.siret || "");
    setName(initialData.name || "");
    setAddr(initialData.address || "");
    setPost(initialData.postalCode || "");
    setCity(initialData.city || "");
    setCountry(initialData.country || "");
    setGender(initialData.principalGender || "Mr");
    setNomC(initialData.principalContact || "");
    setPrenomC(initialData.principalFirstName || "");
    setTelC(initialData.principalPhone || "");
    setMailC(initialData.principalEmail || "");
    setFonctionC(initialData.principalPosition || "");
    setExtras(initialData.otherContacts || []);
    setFormVisible(true);
  }, [initialData]);

  const addExtra = () =>
    setExtras([
      ...extras,
      { civilite: "Mr", nom: "", prenom: "", tel: "", email: "", fonction: "" },
    ]);
  const rmExtra = (i: number) => setExtras(extras.filter((_, k) => k !== i));
  const chExtra = (i: number, f: keyof Contact, v: string) =>
    setExtras(extras.map((c, k) => (k === i ? { ...c, [f]: v } : c)));

  const fillFromInsee = (r: any) => {
    setSiret(r.siret || "");
    setName(r.uniteLegale?.denominationUniteLegale || "");
    const a = r.adresseEtablissement || {};
    setAddr(
      [
        a.numeroVoieEtablissement,
        a.indiceRepetitionEtablissement,
        a.typeVoieEtablissement,
        a.libelleVoieEtablissement,
      ]
        .filter(Boolean)
        .join(" ")
    );
    setPost(a.codePostalEtablissement || "");
    setCity(a.libelleCommuneEtablissement || "");
    setCountry("France");
    setFormVisible(true);
    setShowSearch(false);
    setSearched(false);
  };

  const doSearch = async () => {
    const siren = sirenInput.trim();
    if (!/^\d{9}$/.test(siren)) {
      setResults([]);
      setSearched(true);
      return;
    }
    setLoading(true);
    setSearched(false);
    try {
      const url =
        "https://api.insee.fr/entreprises/sirene/V3.11/etablissements?" +
        new URLSearchParams({ q: `siren:${siren}`, nombre: "20" });
      const resp = await fetch(url, { headers: { "X-Gravitee-Api-Key": INSEE_API_KEY } });
      const data = await resp.json();
      setResults(data.etablissements || []);
    } catch (e) {
      console.error(e);
      setResults([]);
    } finally {
      setLoading(false);
      setSearched(true);
    }
  };

  useEffect(() => {
    if (showSearch) searchRef.current?.focus();
  }, [showSearch]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const now = new Date();
    onSubmit({
      siret,
      name,
      address,
      postalCode,
      city,
      country,
      principalGender: gender,
      principalContact: nomC,
      principalFirstName: prenomC,
      principalPhone: telC,
      principalEmail: mailC,
      principalPosition: fonctionC,
      otherContacts: extras.filter(
        (c) =>
          c.nom.trim() ||
          c.prenom.trim() ||
          c.tel.trim() ||
          c.email.trim() ||
          c.fonction?.trim()
      ),
      createdAt: initialData?.createdAt || now,
      updatedAt: now,
      id: initialData?.id || Date.now(),
    });
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ fontFamily: 'Inter, sans-serif' }}>
        <header className="modal-header">
          <h2 style={{ fontFamily: 'Inter, sans-serif', color: '#424272' }}>{initialData ? "Modifier la société" : "Ajouter une société"}</h2>
          <button className="close-btn" onClick={onClose} aria-label="Fermer" style={{ fontFamily: 'Inter, sans-serif' }}>
            ✕
          </button>
        </header>

        {formVisible && (
          <form onSubmit={handleSubmit} className="societe-form">
            <div className="form-group">
              <label style={{ fontFamily: 'Inter, sans-serif' }}>SIRET :</label>
              <input value={siret} onChange={(e) => setSiret(e.target.value)} style={{ fontFamily: 'Inter, sans-serif' }} />
            </div>
            <div className="form-group">
              <label style={{ fontFamily: 'Inter, sans-serif' }}>Nom :</label>
              <input value={name} onChange={(e) => setName(e.target.value)} required style={{ fontFamily: 'Inter, sans-serif' }} />
            </div>
            <div className="form-group">
              <label style={{ fontFamily: 'Inter, sans-serif' }}>Adresse :</label>
              <input value={address} onChange={(e) => setAddr(e.target.value)} required style={{ fontFamily: 'Inter, sans-serif' }} />
            </div>
            <div className="form-group">
              <label style={{ fontFamily: 'Inter, sans-serif' }}>Code Postal :</label>
              <input value={postalCode} onChange={(e) => setPost(e.target.value)} required style={{ fontFamily: 'Inter, sans-serif' }} />
            </div>
            <div className="form-group">
              <label style={{ fontFamily: 'Inter, sans-serif' }}>Ville :</label>
              <input value={city} onChange={(e) => setCity(e.target.value)} required style={{ fontFamily: 'Inter, sans-serif' }} />
            </div>
            <div className="form-group">
              <label style={{ fontFamily: 'Inter, sans-serif' }}>Pays :</label>
              <select value={country} onChange={(e) => setCountry(e.target.value)} required style={{ fontFamily: 'Inter, sans-serif' }}>
                <option value="" disabled>
                  -- Choisir --
                </option>
                {countries.map((c) => (
                  <option key={c.value} value={c.value}>
                    {c.label}
                  </option>
                ))}
              </select>
            </div>

            <hr />
            <h5 style={{ fontFamily: 'Inter, sans-serif' }}>Contact principal</h5>

            <div className="contact-grid">
              <div>
                <select value={gender} onChange={(e) => setGender(e.target.value)} style={{ fontFamily: 'Inter, sans-serif' }}>
                  <option value="Mr">Mr</option>
                  <option value="Mme">Mme</option>
                </select>
              </div>
              <div>
                <input placeholder="Nom" value={nomC} onChange={(e) => setNomC(e.target.value)} style={{ fontFamily: 'Inter, sans-serif' }} />
              </div>
              <div>
                <input placeholder="Prénom" value={prenomC} onChange={(e) => setPrenomC(e.target.value)} style={{ fontFamily: 'Inter, sans-serif' }} />
              </div>
              <div>
                <input placeholder="Tél." value={telC} onChange={(e) => setTelC(e.target.value)} style={{ fontFamily: 'Inter, sans-serif' }} />
              </div>
              <div>
                <input placeholder="Email" value={mailC} onChange={(e) => setMailC(e.target.value)} style={{ fontFamily: 'Inter, sans-serif' }} />
              </div>
              <div>
                <input placeholder="Fonction" value={fonctionC} onChange={(e) => setFonctionC(e.target.value)} style={{ fontFamily: 'Inter, sans-serif' }} />
              </div>
            </div>

            <h5 style={{ fontFamily: 'Inter, sans-serif' }}>Autres contacts</h5>
            {extras.map((c, i) => (
              <div key={i} className="contact-extra-wrapper">
                <div className="contact-grid">
                  <div>
                    <select value={c.civilite} onChange={(e) => chExtra(i, "civilite", e.target.value)} style={{ fontFamily: 'Inter, sans-serif' }}>
                      <option value="Mr">Mr</option>
                      <option value="Mme">Mme</option>
                    </select>
                  </div>
                  <div>
                    <input value={c.nom} onChange={(e) => chExtra(i, "nom", e.target.value)} placeholder="Nom" style={{ fontFamily: 'Inter, sans-serif' }} />
                  </div>
                  <div>
                    <input
                      value={c.prenom}
                      onChange={(e) => chExtra(i, "prenom", e.target.value)}
                      placeholder="Prénom"
                      style={{ fontFamily: 'Inter, sans-serif' }}
                    />
                  </div>
                  <div>
                    <input
                      value={c.tel}
                      onChange={(e) => chExtra(i, "tel", e.target.value)}
                      placeholder="Tél."
                      style={{ fontFamily: 'Inter, sans-serif' }}
                    />
                  </div>
                  <div>
                    <input
                      value={c.email}
                      onChange={(e) => chExtra(i, "email", e.target.value)}
                      placeholder="Email"
                      style={{ fontFamily: 'Inter, sans-serif' }}
                    />
                  </div>
                  <div>
                    <input
                      value={c.fonction || ""}
                      onChange={(e) => chExtra(i, "fonction", e.target.value)}
                      placeholder="Fonction"
                      style={{ fontFamily: 'Inter, sans-serif' }}
                    />
                  </div>
                </div>
                <div className="remove-contact-button">
                  <button type="button" onClick={() => rmExtra(i)} style={{ fontFamily: 'Inter, sans-serif' }}>
                    ❌
                  </button>
                </div>
              </div>
            ))}

            <button type="button" className="add-contact-button" onClick={addExtra} style={{ fontFamily: 'Inter, sans-serif' }}>
              + Ajouter un contact
            </button>

            <div className="modal-actions">
              <button 
                type="submit" 
                style={{ 
                  fontFamily: 'Inter, sans-serif',
                  backgroundColor: '#424272',
                  color: 'white',
                  border: 'none',
                  padding: '0.6rem 1.2rem',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '0.9rem',
                  transition: 'background-color 0.2s ease',
                  fontWeight: '500'
                }}
              >
                {initialData ? "Enregistrer" : "Créer"}
              </button>
              <button type="button" onClick={onClose} style={{ fontFamily: 'Inter, sans-serif' }}>
                Annuler
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default SocieteModal;
